import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IconCheckmark from '../public/images/checkmark.svg';

const Checkbox = forwardRef(({ className, inputProps, children }, ref) => (
  <label className={classNames('checkbox', className)}>
    <input
      className="checkbox__input"
      type="checkbox"
      {...inputProps}
      ref={ref}
    />
    <span className="checkbox__mark">
      <IconCheckmark aria-hidden="true" />
    </span>
    {children && (
      <span className="checkbox__label">
        {children}
      </span>
    )}
  </label>
));

Checkbox.displayName = 'Checkbox';

Checkbox.propTypes = {
  className: PropTypes.string,
  inputProps: PropTypes.object,
  children: PropTypes.node,
};

export default Checkbox;
